import React, {
  useState,
  useRef,
} from "react";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../mensajes2";

import { Dimmer } from "../../spinner";
import {
  formatMoneda,
  validaSoloNumero,
} from "../../../util/varios";
import moment from "moment";
import { IncluirMovimiento } from "./incluirMovimiento";
import useTable from "../../../components/useTable";
import CatalogoCuentaBancaria from "../../../catalogos/catalogoCuentasBancarias";

import { Input, SearchInput } from "../../../ui/inputs/Input";
import { PrimaryButton } from "../../../ui/buttons/Button";

const     TablaMovimientosBancos = (props) => {
  var op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  let anio = JSON.parse(localStorage.getItem("anioactu"));
  const headCells = [
    {
      id: "idmovimientobancario",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "COD.",
      textAlign: "center",
    },
    {
      id: "tipomov",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "TIPO",
      textAlign: "center",
    },
    {
      id: "referencia",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "REFERENCIA",
      textAlign: "center",
    },
    {
      id: "fecha",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "monto",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const txtIdCuentaBancaria = useRef();
  const txtCuenta = useRef();
  const txtBuscador = useRef();

  const [operacion, setOperacion] = useState(0);
  const [catalogoCuenta, setCatalogoCuenta] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [habilitado, setHabilitado] = useState(false);
  const [idMovimiento, setIdMovimiento] = useState("0");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [idCuenta, setIdCuenta] = useState();
  const [records, setRecords] = useState([]);
  const [regDet, setRegDet] = useState();

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            /*      (st = x.status === '51' ? 'activo' : 'inactivo') */
            if (
              x.idmovimientobancario.includes(target.value) ||
              x.tipo.toLowerCase().includes(target.value.toLowerCase()) ||
              x.referencia.toLowerCase().includes(target.value.toLowerCase()) ||
              moment.utc(x.fecha)
                .format("DD/MM/YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              formatMoneda(
                x.monto.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              )
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const seleccionarMovimientos = (id) => {
    let annio = parseInt(anio) - 2;
    let endpoint = `${
      op.conexion
    }/api/Caja_Ingreso/movimientosdebitocredito?idcuenta=${id}&fecha=${
      "31-12-" + annio.toString()
    }`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords([]);
          if (response.data.length > 0) {
            var movi = [];
            for (let i = 0; i < response.data.length; i++) {
              movi.push({
                idmovimientobancario: response.data[i].idmov,
                idcuentabancaria: response.data[i].doc_idctab,
                fecha: response.data[i].doc_fechar,
                fechasis: response.data[i].doc_fechae,
                referencia: response.data[i].doc_numero,
                motivo: response.data[i].doc_descri,
                monto: response.data[i].doc_monto,
                tipo: response.data[i].mov_tipo,
                fechareversado: response.data[i].fechareverso,
                id: response.data[i].id,
              });
            }
            setRecords(movi);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);
  const seleccionarCuentaBancaria = (id) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid} `;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtCuenta.current.value =
              response.data.nombre.trim() +
              " --- " +
              response.data.cuentabancaria.trim();
            seleccionarMovimientos(response.data.idcuentabancaria);
            setIdCuenta(response.data.idcuentabancaria);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "ID no existe.",
              icono: "informacion",
            });
            txtIdCuentaBancaria.current.value = "";
            txtIdCuentaBancaria.current.focus();
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistro = (id, nomtab, nomid) => {
    let campos = "*";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setRegDet(response.data);
            setMostrar(true);
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const gestionarMovimiento = (op, id, index) => (e) => {
    setOperacion(op);
    setIdMovimiento(id);
    if (op === 4) {
      setHabilitado(false);

      let nomtab =
        recordsAfterPagingAndSorting()[index].tipo === "15"
          ? "deposito"
          : "debitocredito";
      let nomid =
        recordsAfterPagingAndSorting()[index].tipo === "15"
          ? "iddeposito"
          : "iddebitocredito";

      seleccionarRegistro(
        recordsAfterPagingAndSorting()[index].id,
        nomtab,
        nomid
      );
    } else if (op === 1) {
      if (
        txtIdCuentaBancaria.current.value === "" ||
        txtCuenta.current.value === ""
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar una Cuenta Bancaaria.",
          icono: "informacion",
        });
        return;
      }
      setHabilitado(true);
      setMostrar(true);
    } else if (op === 2) {
      setHabilitado(true);

      if (recordsAfterPagingAndSorting()[index].conciliado === 1) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El movimiento no se puede modificar, ya está conciliado.",
          icono: "informacion",
        });
        return;
      }

      let nomtab =
        recordsAfterPagingAndSorting()[index].tipo === "15"
          ? "deposito"
          : "debitocredito";
      let nomid =
        recordsAfterPagingAndSorting()[index].tipo === "15"
          ? "iddeposito"
          : "iddebitocredito";

      seleccionarRegistro(
        recordsAfterPagingAndSorting()[index].id,
        nomtab,
        nomid
      );
    } else if (op === 5) {
      setHabilitado(false);
      let nomtab =
        recordsAfterPagingAndSorting()[index].tipo === "15"
          ? "deposito"
          : "debitocredito";
      let nomid =
        recordsAfterPagingAndSorting()[index].tipo === "15"
          ? "iddeposito"
          : "iddebitocredito";

      seleccionarRegistro(
        recordsAfterPagingAndSorting()[index].id,
        nomtab,
        nomid
      );
    } else if (op === 3) {
      setHabilitado(false);

      let nomtab =
        recordsAfterPagingAndSorting()[index].tipo === "15"
          ? "deposito"
          : "debitocredito";
      let nomid =
        recordsAfterPagingAndSorting()[index].tipo === "15"
          ? "iddeposito"
          : "iddebitocredito";

      seleccionarRegistro(
        recordsAfterPagingAndSorting()[index].id,
        nomtab,
        nomid
      );
    }
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const validarCuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuentaBancaria(event.target.value);
      } else {
        txtCuenta.current.value = "";
      }
    }
  };

  const onChange = (e) => {
    if (e.target.name === "idcuentabancaria") {
      txtCuenta.current.value = "";
      setRecords([]);
    }
  };

  const onCatalogoCuenta = (values) => {
    setCatalogoCuenta(false);
    txtIdCuentaBancaria.current.value = values.idcuentabancaria;
    seleccionarCuentaBancaria(values.idcuentabancaria);
  };
  const render = () => {
    setRecords([]);
    setRegDet();
    seleccionarCuentaBancaria(idCuenta);
    setMostrar(false);
  };

  const cerrar = () => {
    props.setTabla(0);
  };
  return (
    <div className="col-8 m-0 p-0 mx-auto mt-5">
      {props.modulo && props.modulo === "admin" 
      ? <div className="col-12 m-0 px-4 py-2 rounded-top azulGradiant text-white d-flex justify-content-between align-items-center">
          <h3 className="m-0">Gestion de Movimientos Bancarios</h3>
          <a type="button" onClick={cerrar}>
            salir<i className="fa fa-times "></i>
          </a>
        </div>
       : <div className="col-12 m-0 px-4 py-2 rounded-top azulGradiant text-white d-flex justify-content-between align-items-center">
          <h3 className="m-0">Gestion de Movimientos Bancarios</h3>
          <a type="button" onClick={cerrar}>
            salir<i className="fa fa-times"></i>
          </a>
        </div>
      }
      <div className="col-12 m-0 p-2">
        <fieldset className="col-12 p-2 m-0 my-2 d-flex border-azul rounded">
          <legend className="float-none w-auto m-0">Cuenta Bancaria</legend>
          <div className="col-4 col-lg-2 m-0 p-0">
            <SearchInput label = 'Código:'
              name="idcuentabancaria"
              onKeyUp={validarCuenta}
              onChange={onChange}
              onClickButton={() => {
                setCatalogoCuenta(true);
              }}
              ref={txtIdCuentaBancaria}
            />
          </div>
          <Input
            disabled
            name="cuentabancaria"
            ref={txtCuenta}
          />
        </fieldset>
      </div>
      <div className="col-12 m-0 p-2">
        <fieldset className="col-12 m-0 p-2 border-azul rounded">
          <legend className="float-none w-auto">Movimientos</legend>
          <div className="col-12 p-0 m-0 mb-2 d-flex justify-content-between align-items-center">
            <div className="col-6 col-lg-4 m-0 p-0">
              <Input
                onChange={handleSearch}
                placeholder="Buscar"
                ref={txtBuscador}
              /> 
            </div>
            <PrimaryButton icon = "fas fa-plus m-0" onClick={gestionarMovimiento(1, "", "")}>
            </PrimaryButton>
          </div>
          <div className="col-12 p-0 m-0">
            <TblContainer>
              <TblHead />
              <tbody>
                {records &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <tr key={index} style={{ padding: "0" }}>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          width: "240px",
                        }}
                      >
                        {item.idmovimientobancario
                          ? item.idmovimientobancario
                          : ""}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          width: "240px",
                        }}
                      >
                        {item.tipo
                          ? item.tipo === "15"
                            ? "DEPOSITO"
                            : item.tipo === "16"
                            ? "NOTA DE DEBITO"
                            : item.tipo === "17"
                            ? "NOTA DE CREDITO"
                            : ""
                          : ""}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          width: "240px",
                        }}
                      >
                        {item.referencia ? item.referencia : ""}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          width: "270px",
                        }}
                      >
                        {item.fecha
                          ? moment.utc(item.fecha).format("DD/MM/YYYY")
                          : ""}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          width: "270px",
                        }}
                      >
                        {item.monto
                          ? formatMoneda(
                              item.monto
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                          : ""}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                          width: "330px",
                        }}
                      >
                        {item.fechareversado ? (
                          ""
                        ) : (
                          <button
                            onClick={gestionarMovimiento(
                              3,
                              item.idmovimientobancario,
                              index
                            )}
                            className="btn btn-sm mx-1 btn-success rounded-circle"
                            title="Reversar"
                          >
                            <i className="fa fa-backward"></i>{" "}
                          </button>
                        )}
                        <button
                          onClick={gestionarMovimiento(
                            4,
                            item.idmovimientobancario,
                            index
                          )}
                          className="btn btn-sm mx-1 btn-info rounded-circle"
                        >
                          <i className="fas fa-eye"></i>{" "}
                        </button>
                        {item.fechareversado ? (
                          ""
                        ) : (
                          <button
                            onClick={gestionarMovimiento(
                              2,
                              item.idmovimientobancario,
                              index
                            )}
                            className="btn btn-sm mx-1 btn-warning rounded-circle"
                          >
                            <i className="fa fa-edit"></i>{" "}
                          </button>
                        )}
                        <button
                          onClick={gestionarMovimiento(
                            5,
                            item.idmovimientobancario,
                            index
                          )}
                          className="btn btn-sm mx-1 btn-danger rounded-circle"
                        >
                          <i className="fa fa-trash"></i>{" "}
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </TblContainer>
            <TblPagination />
          </div>
        </fieldset>
      </div>
      <IncluirMovimiento
        show={mostrar}
        operacion={operacion}
        idcuentabancaria={
          txtIdCuentaBancaria.current ? txtIdCuentaBancaria.current.value : "0"
        }
        idmovimiento={idMovimiento}
        habilitado={habilitado}
        registro={regDet}
        idCuenta={idCuenta}
        onHideCancela={() => {
          setMostrar(false);
        }}
        onHideRenderizar={render}
      />
      <CatalogoCuentaBancaria
        show={catalogoCuenta}
        onHideCancelar={() => {
          setCatalogoCuenta(false);
        }}
        onHideAceptaCatalogo={onCatalogoCuenta}
      />

      <Dimmer active={activate} inverted></Dimmer>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaMovimientosBancos;
